import type { VoxServiceCardResponse, VoxServiceProductResponse } from '@/core/generated/api';
import { SERVICE_PET_TYPES_OPTIONS } from '@/entities/constants';

/** Выбирает продукты без другой карточки услуги */
export const getAvailableVoxServiceProducts = (
    products: VoxServiceProductResponse[],
    cards: VoxServiceCardResponse[],
    current?: VoxServiceCardResponse,
) => {
    const occupied = new Set(cards.filter(card => card.id !== current?.id).map(card => card.productId));

    const options = products.filter(product => !occupied.has(product.id))
        .map(product => ({
            id: product.id ?? '',
            name: `${product.name} · ${SERVICE_PET_TYPES_OPTIONS.find(type => type.id === product.petType)?.name ?? 'Все питомцы'}`,
        }));

    if (current?.productId && !options.some(option => option.id === current.productId)) {
        options.push({
            id: current.productId,
            name: `${current.productName} (продукт недоступен)`,
        });
    }

    return options;
};
